"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = false;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0"; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate";
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal();
  calculateSubTotalWithDiscount();
  /*cart numeric type*/

  $(".js__cart__quantity-selector").keypress(function (event) {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();

      if ($(this).val() == "0") {
        $(this).val("1");
      }

      var lineCount = $(this).attr("data-cart-line-count");
      updateQuantity(lineCount);
      return false;
    }
  });
});
/*
EVENTS
1. Update quantity
2. minus quantity
3. plus quantity
4. remove item from cart
5. reload ajax cart
6. quickCartTotal
7. calculateSubTotalWithDiscount
8. cart.requestComplete
*/
//QUANTITY UPDATE

function updateQuantity(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  /* NOTE: you will not get Raw Inventory against the variant in API calls */

  /* PENDING, need to find a solution for this */

  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/

  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */

  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {//console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}

function minusQuantity(cartThis) {
  // debugger;
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity - 1;
  $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);

  if (newQuantity < 1) {
    removeItem(lineItemCount);
  } else {
    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {},
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      }
    });
    /*
    if you want to update item by ID and not by line item then you can use updateItemId function
    Recommended - line item update
    CartJS.updateItemById(lineIndex, newQuantity);
    */
  }
}

function plusQuantity(cartThis) {
  // debugger;
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity + 1;
  /* NOTE: you will not get Raw Inventory against the variant in API calls */

  /* PENDING, need to find a solution for this */

  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/

  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */

  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {//console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
} //REMOVE ITEM


function removeItem(lineItemCount) {
  CartJS.removeItem(lineItemCount, {
    success: function success(data, textStatus, jqXHR) {},
    error: function error(jqXHR, textStatus, errorThrown) {//console.log('Error: ' + errorThrown + '!');
    }
  });
} //RELOAD AJAX CART


function reloadAjaxCartItemUsingCartAjaxObject(data) {
  var lineCount = 1;
  var cartObject; //console.log(data);

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".cart-list").html("");
  $(cartObject.items).each(function () {
    var imageURL = this.featured_image.url;
    var imageAlt = this.featured_image.alt;
    var itemPrice = this.original_price;
    var handle = this.handle;
    var itemID = this.id;
    var comparePrice = "";
    /* get compare price using cartLib object */

    if (typeof cartLib !== "undefined") {
      $.each(cartLib, function (key, value) {
        //console.log(value);
        if (value["id"] == itemID) {
          comparePrice = value["comparePrice"];
        }
      });
    }
    /* FORMATTED PRICING */


    var formattedcomparePrice = comparePrice / 100;
    formattedcomparePrice = formatter.format(formattedcomparePrice); //console.log(imageURL);
    // check if the compared price is greater then item price then only show the compared price

    var comparePriceHtml = "";

    if (comparePrice > parseFloat(itemPrice)) {
      comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
    }

    var totalListItemComparePrice = comparePrice * this.quantity;
    totalListItemComparePrice = totalListItemComparePrice / 100;
    totalListItemComparePrice = formatter.format(totalListItemComparePrice);
    var formattedItemTotalPrice = itemPrice * parseInt(this.quantity) / 100;
    formattedItemTotalPrice = formatter.format(formattedItemTotalPrice);
    var formattedItemPrice = itemPrice / 100;
    formattedItemPrice = formatter.format(formattedItemPrice); //console.log(imageURL);

    /* Bind the properties */

    var itemProperties = "";
    var itemPropertiesElement = "";
    var itemPropertiesMainElement = "";
    var boolItemBoxType = false;
    var displayClass = "";
    var readonly = "";
    var justifyCenter = "";
    var formattedItemPriceMiniCart = formattedItemPrice;
    /* Item properties */

    if (this.properties != null) {
      itemProperties = this.properties; //console.log(itemProperties);

      if (Object.keys(itemProperties).length > 0) {
        itemPropertiesElement = "<ul>";
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == "Box ID") {
            displayClass = "hide";
            readonly = "readonly='readonly'";
            boolItemBoxType = true;
            justifyCenter = "justify-center "; // if you do not want to show the price and compared price in cart and mini cart then open the below variables
            // formattedItemPrice="-";
            // formattedcomparePrice="-";
            // formattedItemTotalPrice="-";
            // formattedItemPriceMiniCart="";
          }

          if (key.indexOf("_") > -1) {} else {
            itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
            itemPropertiesElement += "</li>";
          }
        });
        itemPropertiesElement += "</ul>"; //console.log(itemPropertiesElement);

        itemPropertiesMainElement = itemPropertiesElement;
      } else {
        itemPropertiesElement = "";
      }
    }

    var sellingPlayInformation = "";

    if (this.selling_plan_allocation != undefined) {
      sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
    }
    /* check if variantTitle is NULL, then don't show variant */


    var variantTitle = this.variant_title;

    if (variantTitle == null) {
      variantTitle = "";
    }
    /* 
    LINE ITEM FOR THE MINI CART
    */
    //elements


    var priceElement = " <p class='js__raw-line-item-price price'>" + formattedItemPrice + "</p>"; // remove anchor

    var removeAnchorElement = '<div class="remove js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + '" data-cart-line-count=' + lineCount + ">Remove</div>";
    var lineItem;
    lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + this.url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
    lineItem += '<div class="content"><h5><a href="' + this.url + '">' + this.product_title + "</a></h5>";

    if (sellingPlayInformation != "") {
      lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
    }

    if (itemPropertiesElement != "") {
      lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
    }

    if (variantTitle != "") {
      lineItem += '<p class="capitalize">' + variantTitle + "</p>";
    }

    lineItem += priceElement + '<div class="flex-space-between"><p class="hide">Qty ' + this.quantity + '</p><p class="cart-quantity-outer ' + justifyCenter + '"> <a class="minus-qty ' + displayClass + '" data-cart-line-count=' + lineCount + '" onclick="minusQuantity(' + lineCount + ')" data-variant-id=' + itemID + " ></a> <input " + readonly + ' onkeydown="return isNumeric(event);" type="text"  data-cart-line-count=' + lineCount + ' class="cart__quantity-selector js__cart__quantity-selector" aria-label="Qty" name="updates[]" value="' + this.quantity + '" maxlength="3" size="3"><a class="plus-qty ' + displayClass + '" data-cart-line-count=' + lineCount + ' onclick="plusQuantity(' + lineCount + ')" data-variant-id=' + itemID + "></a> </p>";
    lineItem += removeAnchorElement + "</div></div>";
    lineItem += "</li>";
    /* Bind the line item to the list */

    $(".js__ajax-products-bind").append(lineItem); //LINE ITEM FOR THE CART PAGE
    // elements

    var quantityElement = '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '">  <div class="cart-quantity-outer ' + justifyCenter + '"> <a  class="minus-qty ' + displayClass + ' font-zero" onclick="minusQuantity(' + lineCount + ')"   data-variant-id="' + itemID + '"><svg width="13" height="1" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h13v1H0z" fill="#404040" fill-rule="nonzero"/></svg></a> <input ' + readonly + ' onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + ':20aaf9fd79516fa50b83805e363ee55b" value="' + this.quantity + '" maxlength="3" size="3"> <a class="plus-qty ' + displayClass + ' font-zero" onclick="plusQuantity(' + lineCount + ')"     data-variant-id="' + itemID + '"><svg width="13" height="13" xmlns="http://www.w3.org/2000/svg"><path d="M7 0v6h6v1H7v6H6V7H0V6h6V0h1z" fill="#404040"  fill-rule="nonzero"/></svg></a> </div> <span class="js__out-of-stock"></span>  ';
    var vendorElement = '<span class="subheading uppercase">' + this.vendor + '</span>';

    if ($(".cart-list")[0]) {
      //classLineItem = ".js__set-line-item-price";
      var cartLineItem = "";
      cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></div> <div class="content">';

      if (showVendorOnCartPage) {
        cartLineItem += vendorElement;
      }

      cartLineItem += '<a class="item-name" href="' + this.url + '"> <span class="item-title">' + this.product_title + " </span></a>";
      cartLineItem += '<div class="cart-list__variant-properties">';

      if (sellingPlayInformation != "") {
        cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
      }

      if (itemPropertiesElement != "") {
        cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
      }

      if (variantTitle != "") {
        cartLineItem += '<span class="capitalize">' + variantTitle + "</span>";
      }

      cartLineItem += "</div>";
      cartLineItem += '<a class="remove btn-border-small-black tab-none" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  </div>  <div class="cart-list__items__columns">  <!-- Show Sale Price--> <span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + ':20aaf9fd79516fa50b83805e363ee55b">' + formattedItemPrice + "</span></span>  </div>";
      cartLineItem += quantityElement + ' <a class="remove btn-border-small-black tab-block " data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  <div class="cart-list__items__columns total-price price-wrapper" data-head="Total"> <span class="js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + ':20aaf9fd79516fa50b83805e363ee55b">' + formattedItemTotalPrice + "</span> </span> <!-- Show Sale Price-->   </div>     </div>";
      $(".cart-list").append(cartLineItem);
    }

    lineCount++;
  });
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}

function calculateSubTotalWithDiscount() {
  var subTotal = 0;
  var discount = 0;
  var total = 0;
  var lineItemComparePrice = 0;
  var itemPrice = 0;
  var quantity = 0;
  /* loop through eachcart item and get the compared price and actual price */

  if (typeof cartLib !== "undefined") {
    $.each(cartLib, function (key, value) {
      quantity = parseInt(value.quantity);
      lineItemComparePrice = parseInt(value.comparePrice) * quantity;
      itemPrice = parseInt(value.price) * quantity;
      subTotal += lineItemComparePrice;
      discount += lineItemComparePrice - itemPrice;
    });
    total = CartJS.cart.total_price; //format

    subTotal = subTotal / 100;
    subTotal = formatter.format(subTotal);
    discount = discount / 100;
    discount = formatter.format(discount);
    total = total / 100;
    total = formatter.format(total);
  }

  if (CartJS.cart.item_count > 0) {
    $(".js__cart-sub-total").html(subTotal);
    $(".js__cart-total-saved").html("-" + discount);
    $(".js__cart-total").html(total);

    if (showCartCountInTopNav) {
      $(".js__ajax-cart-count").show();
      $(".js__ajax-cart-count").html(CartJS.cart.item_count);
    }

    $(".free-shipping").show(); //show/hide js__cartSubtotalDiscountWraper - if you want to show subtotal and discount

    showCartSubTotalDiscountSection ? $(".js__cartSubtotalDiscountWraper").removeClass("hide") : console.log("SubTotal Discount Wrapper not visible");
  } else {
    /* 
    update cart item count = 0
    hide the totals
    hide checkout buttons
    update the icon cart with a different icon
    */
    $(".js__ajax-products-bind").html('<li><div class="width-100"> <p class="uppercase text-center">Your cart is empty</p> </div></li>');
    $(".freq-product-list").hide();
    $(".free-shipping").hide();
    $(".js__ajax-cart-count").html(cartCountEmptyValue);
    $(".js__ajax-cart-total").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__show-cart-items-section").hide();
    $(".empty-cart-section").show();
    $(".js__cart-expand ").addClass("empty-cart"); //change the icon for the top cart, if required

    showEmptyCartIcon ? $(".js__update-cart-icon").addClass("empty-cart") : console.log("icon not changed");
  }
}
/*
  CUSTOM-- for the BUILDER
  THIS FUNCTION IS USED WHEN THERE IS NO QUANTITY BOX VISIBLE AGAINST THE ITEM
  //Variest from theme to theme
   1. Loop through cart items
   2. If item has property > 0 
   3. Then check for "Box ID" 
   4. Save the BoxID in a variable
   5. Then go through the second cart item
   6. if currentItemPropertyBoxID = savedItemPropertyBoxID
   7. Then remove the item
   8. Else do not do anything
*/


var savedItemPropertyBoxID = "";
var currentItemPropertyBoxID = "";
var clickedRemoveItemStatus = false;
var currentItemID = "";
$(document).on("click", ".remove", function () {
  var howManyItemsToDelete = 0;
  var variantID = parseInt($(this).attr("data-variant-id"));
  var itemLineCount = parseInt($(this).attr("data-cart-line-count"));
  var extraItemLineCount = 1; //console.log(itemLineCount);
  //Run properties loop

  $(CartJS.cart.items).each(function () {
    if (itemLineCount == extraItemLineCount) {
      //console.log("variantID : " + variantID);
      $.each(this.properties, function (key, value) {
        //console.log("key" + key);
        if (key == "Box ID") {
          //console.log("key" + key);
          savedItemPropertyBoxID = value;
          clickedRemoveItemStatus = true;
        }
      });
    }

    extraItemLineCount = extraItemLineCount + 1;

    if (clickedRemoveItemStatus) {
      clickedRemoveItemStatus = false;
      return false;
    }
  }); //console.log("savedItemPropertyBoxID : " + savedItemPropertyBoxID);

  extraItemLineCount = 1;
  /* Loop through items again to get the */

  $(CartJS.cart.items).each(function () {
    //console.log("############");
    //console.log(extraItemLineCount);
    //console.log(this.title);
    //console.log(this.id);
    currentItemID = this.id;
    $.each(this.properties, function (key, value) {
      if (key == "Box ID") {
        //console.log("Property Match");
        currentItemPropertyBoxID = value; //console.log("currentItemPropertyBoxID: " + currentItemPropertyBoxID);
        //console.log("savedItemPropertyBoxID: " + savedItemPropertyBoxID);

        if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
          //console.log("remove the current item");
          extraItemLineCount = 1;
          howManyItemsToDelete = howManyItemsToDelete + 1; //Remove the product that clicked
        } else {
          extraItemLineCount = extraItemLineCount + 1;
        }
      }
    });
  }); //console.log("howManyItemsToDelete: " + howManyItemsToDelete);

  if (howManyItemsToDelete == 0) {
    removeItem(itemLineCount);
  } else {
    var n;

    (function () {
      /* 
      Remove the items depending upon how many are to be deleted
      Run the loop again and delete them one by one 
      */
      var currentItemLoop = 1;

      for (n = 0; n < howManyItemsToDelete; ++n) {
        //debugger;
        $(CartJS.cart.items).each(function () {
          //console.log(this.title);
          //console.log(this.properties);
          debugger;

          if (jQuery.isEmptyObject(this.properties)) {
            //console.log("Property is empty");
            currentItemLoop = currentItemLoop + 1;
          } else {
            $.each(this.properties, function (key, value) {
              if (key == "Box ID") {
                currentItemPropertyBoxID = value;

                if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
                  //console.log("remove the final loop item");
                  removeItem(currentItemLoop);
                  currentItemLoop = 1; //Remove the product that clicked
                } else {
                  currentItemLoop = currentItemLoop + 1;
                }
              }
            });

            if (currentItemLoop == 1) {
              return false;
            }
          }
        });
      }
    })();
  }

  showHideEmptyCart();
});

function showHideEmptyCart() {
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
}
/*
PROGRESS BAR
*/


function progressBar() {
  if (showProgressBar) {
    var totalAmount = CartJS.cart.total_price / 100;
    var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
    var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
    var freeShippingPercentage = 100;

    if (freeShippingRemaningAmount > 0) {
      freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
      $(".js__free-shipping-limit-message").show();
      $(".js__free-shipping-message").hide();
    } else {
      $(".js__free-shipping-limit-message").hide();
      $(".js__free-shipping-message").show();
    }

    $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
    $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
    $(".js__free-shipping__progress-bar").children("span").css("width", freeShippingPercentage + "%");
  }
}
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/


$(document).ready(function ($) {
  $(".js__addon-add-to-cart").click(function () {
    var quantity = 1;
    var addonSelectedVariantID = $(this).attr("data-attr-variantid");
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
  $(".js__addon-add-to-cart").keypress(function () {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();
      var quantity = 1;
      var addonSelectedVariantID = $(this).attr("data-attr-variantid");
      cartAddItemAddon(addonSelectedVariantID, quantity);
    }
  });
});

function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function success(data, textStatus, jqXHR) {//console.log("success");

      /* Pending - Remove the selected addon when add to cart is clicked */
    },
    error: function error(jqXHR, textStatus, errorThrown) {//console.log("error");
    }
  });
}

function addons() {
  //console.log("addons");

  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler"); // if cartAddon is null,

    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false; // going through the string and checking if the current addon handle = the addon
      //handle present in the string

      var cartAddons2 = cartAddons.split(",");

      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      } // add the new addon handle to the string


      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    } //console.log(cartAddons);

    /* Hide the addons from the addon list, if the addon is present in the cart */


    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle"); // console.log("itemHandle"+itemHandle);
      // console.log("addoneHandle"+addoneHandle)

      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });

    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  /* Hide the complete section if there are no addons */

  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  }); //console.log("boolAddonExist"+boolAddonExist);

  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
} //Addons are fetched from the schemas; Varies from theme to theme


setTimeout(function () {
  addons();
}, 1000);
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Mini cart - Checkout Button visiblity fix for IOS Mobile */
var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }

    lastScroll = scroll;
  });
});
jQuery(function () {
  var _$$not$slick;

  /* Identify Psage with inner banner */
  if ($("div").hasClass("inner-hero-section") === true) {
    $("body").addClass("inner-banner-page");
  }

  try {
    /*Pagination number*/
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemEnd);
  } catch (_unused) {}
  /* SLIDER */


  $(".js__three-column-slider-section").not(".slick-initialized").slick((_$$not$slick = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true,
    draggable: true,
    centerMode: false,
    swipeToSlide: false,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }]
  }, _defineProperty(_$$not$slick, "responsive", [{
    breakpoint: 900,
    settings: {
      slidesToShow: 4,
      infinite: true
    }
  }]), _defineProperty(_$$not$slick, "responsive", [{
    breakpoint: 400,
    settings: {
      slidesToShow: 4,
      infinite: true
    }
  }]), _$$not$slick));
  $(".js__three-column-pdp-recommendation-slider-section").not(".slick-initialized").slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true,
    draggable: true,
    responsive: [{
      breakpoint: 769,
      settings: {
        arrows: true
      }
    }]
  });
  $(".js__testimonial-home").not(".slick-initialized").slick({
    dots: true,
    slidesToShow: 1,
    arrows: false,
    infinite: false,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: true,
    draggable: true,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: false
      }
    }]
  });
  $(".js__home-product-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    draggable: true
  });
  /* HOME
  Hero Banner SLider */

  $(".js__hero-slider").not(".slick-initialized").slick({
    dots: true,
    slidesToShow: 1,
    arrows: false,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: true,
    variableWidth: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 1175,
      settings: {
        dots: false,
        draggable: true,
        autoplay: true
      }
    }]
  });
  /*Slider arrows click*/

  var sliderCount = 0;
  $(".js__hero-slider .slick-next").click(function (e) {
    sliderCount++;
    heroSliderVideo("video" + sliderCount);
  });
  /*Slider arrows click*/

  $(".js__hero-slider .slick-prev").click(function (e) {
    sliderCount--;
    heroSliderVideo("video" + sliderCount);
  });
  /*Slider dots click*/

  $(".js__hero-slider .slick-dots li").click(function (e) {
    e.preventDefault();
    var slideIndex = $(this).index();
    heroSliderVideo("video" + slideIndex); // $('.js__hero-slider').slickGoTo(parseInt(slideIndex));

    sliderCount = slideIndex;
  });
  var videoID;
  /*for video play and pause  dots click*/

  function heroSliderVideo(id) {
    try {
      videoID.pause();
    } catch (_unused2) {}

    try {
      $("iframe").vimeo("pause");
    } catch (_unused3) {}

    try {
      videoID = document.getElementById(id);
      videoID.play();
    } catch (_unused4) {}

    try {
      setTimeout(function () {
        $("#" + id).vimeo("play");
      }, 500);
    } catch (_unused5) {}
  }

  $(".js__hero-slider .slider-nav").on("click", ".slick-slide", function () {
    //Get the data-slick-index property so we know what slide to switch to
    actIndex = $(this).attr("data-slick-index"); //Select the .slider-for dom elements and put into a variable (only one for me)

    var slider = $(".slider-for"); //Send the .slider-nav to the slide that was clicked

    slider[0].slick.slickGoTo(parseInt(actIndex));
  });
  var $status = $(".js__slide-count");
  var $slickElement = $(".js__hero-slider");
  var $slideCount = 0;
  $(".js__hero-slider .slide").each(function () {
    if (!$(this).hasClass("slick-cloned")) {
      $slideCount++;
    }
  });
  $status.text("1" + " / " + $slideCount);
  $slickElement.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + " / " + slick.slideCount);
  });
  /* PDP
  Tab working */

  $(".tab-link").on("click", function () {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
  });
  /* GLOBAL
  Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  /* accordion working about content in small screen*/

  $(".js__accordian").children("li").children("h5,h6,h3").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
});
/** Dropdown **/

jQuery(function ($) {
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }

    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      console.log($(this).html());

      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }

      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
  $(".js__active-class li a").each(function () {
    if (this.href === path) {
      $(".js__active-class li a").removeClass("active");
      $(this).addClass("active");
    }
  });
});
"use strict";

jQuery(function () {
  //Cart - Free Shipping Progress bar Visiblity
  if (getglobalLib("Free_Shipping_progressbar") == "yes") {
    $(".js__progressbar_visiblity").removeClass("hide");
  }
  /* Footer - Accordion Visiblity */


  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle");
    $(".js__accordion-content-visiblity").addClass("accordion-content");
  }
  /* FAQ - Category Sidebar Visiblity */


  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  } //Nav - Open and Close Mini cart


  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js-cart-expand").on("click", function () {
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active");
      $(this).addClass("active");
    });
    $("#js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js-cart-expand").removeClass("active");
    });
    $(".js-cart-expand").attr("href", "javascript:void(0)");
  }
  /* Remove mini cart from the cart page */


  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });

  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/

function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);
  $("#cart-message").addClass("message-success");
  $("#cart-message").removeClass("message-error");
  $("#cart-message").html("Successfully added to cart!");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function showCartErrorMessage() {
  $("#cart-message").removeClass("message-success");
  $("#cart-message").addClass("message-error");
  $("#cart-message").html("Sorry! Seems like the product is out of stock");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function openMiniCart() {
  if (CartJS.cart.item_count > 0) {
    $("#CartSidebar").toggleClass("active");
    $("#cart_overlay").toggleClass("active");
  }
}
/* EVENT: When the cart request is completed everytime the below function is run */


$(document).on("cart.requestComplete", function (event, cart) {
  console.log("On cart request complete");
  reloadAjaxCartItemUsingCartAjaxObject(cart); //Progress Bar of shipping in cart and mini cart; Varies from theme to theme

  progressBar(); //Show and hide empty cart depending upon the cart items

  setTimeout(function () {
    calculateSubTotalWithDiscount();
    addons();
  }, 1000);
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  $(".js__announcement-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    vertical: true,
    cssEase: "ease-in-out",
    adaptiveHeight: true
  });
  /* Announcement 
  Close on Click  */

  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });
  /* MEGAMENU
    active link while submenu open */
  // $(window).resize(function(){location.reload();});

  jQuery(function ($) {
    $(window).resize(function () {
      var windowWidth = $(window).width();

      if (windowWidth < 980) {
        $(".has-big-nav .site-nav__link,.has-big-nav .submenu").mouseover(function () {
          $(".has-big-nav .site-nav__link").removeClass("hover-submenu");
          $(".js__main-header").removeClass("active");
        });
        $(".has-big-nav .site-nav__link,.has-big-nav .submenu").mouseout(function () {
          $(".has-big-nav .submenu").show();
        });
        return;
      }
    });
  });

  if ($(window).width() > 980) {
    $(".has-big-nav .site-nav__link,.has-big-nav .submenu").mouseover(function () {
      $(".has-big-nav .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav .submenu").show();
      $(".js__main-header").addClass("active");
    });
    $(".has-big-nav .site-nav__link,.has-big-nav .submenu").mouseout(function () {
      $(".has-big-nav .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav .submenu").hide();
      $(".js__main-header").removeClass("active");
    });
  }
  /* SubMenu
  Accordion JS */


  (function ($) {
    $(function () {
      var navLink = false;
      $(".accordion-toggle").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();

        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 601) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").slideUp(300);
          } else {
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").slideDown(300);
          }
        }

        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 601) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content").slideUp(300);
              } else {
                $(".accordion-toggle").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content").slideUp(300);
                $(this).siblings(".accordion-content").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        }
      });
    });
  })(jQuery);

  $(".has-big-nav .site-nav__link").on("click", function () {
    $(this).toggleClass("active");
    $(".submenu").toggleClass("active");
  });
  /** HEADER **/

  /** Top Search Open Close **/

  $(".js__search-popup,.js__close-search-popup").on("click", function () {
    $(".js__header-search").toggleClass("active");
    $(".js__main-header").toggleClass("active");
  });
});
/** Fix Header on Scroll **/

$(window).scroll(function () {
  var sticky = $("header"),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    sticky.addClass("fixed");
    $(".js__logo").addClass("active");
  } else {
    sticky.removeClass("fixed");

    if ($("#navbarNavDropdown").hasClass("active")) {
      $(".js__logo").addClass("active");
    } else {
      $(".js__logo").removeClass("active");
    }
  }
});
/** Mobile Navigation Open Close **/

(function ($) {
  $(function () {
    var navLink = false;
    $("#hamburger").mousedown(function (e) {
      // $(this).toggleClass("active");
      $("#navbarNavDropdown").toggleClass("active");
      $(".js__overlay").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        // $(this).toggleClass("active");
        $("#navbarNavDropdown").toggleClass("active");
        $(".js__overlay").toggleClass("active");
      }
    });
  });
})(jQuery);

(function ($) {
  $(function () {
    var navLink = false;
    $("#hamburger-close").mousedown(function (e) {
      // $(this).toggleClass("active");
      $("#navbarNavDropdown").toggleClass("active");
      $(".js__overlay").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        // $(this).toggleClass("active");
        $("#navbarNavDropdown").toggleClass("active");
        $(".js__overlay").toggleClass("active");
      }
    });
  });
})(jQuery);
/** CART SIDEBAR
 * Close on Outside Click
 * **/


$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");

  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
  }
});
"use strict";

$(document).ready(function ($) {
  var successErrorMessageVisible = false;
  var secondOptionVariantValue = "";
  var colorSelected = "";
  var thirdOptionVariantValue = "";
  var variantOptionArray = {};
  var selectedVariantArray;
  var selectedVariantID;
  var colorSwatchLimit = parseInt(getglobalLib("Color_Swatches_Limit"));
  var colorPosition = $("#colorPosition").val();
  /*Basic setting */

  /*Varient basic setting dropwon or radio button*/

  if (getglobalLib("Variant_Display") == "dropdown") {
    $(".pdp-size-section").addClass("pdp-option-dropdown-section");
  }
  /*Varient color swatch in on off*/


  if (getglobalLib("Color_Swatches") == "yes") {
    $(".js-variant-color").addClass("swatch-variant-color");
  } else {
    if (getglobalLib("Variant_Display") == "dropdown") {
      $(".pdp-color-section").addClass("pdp-option-dropdown-section");
      $(".pdp-color-section").addClass("js__colorDropdown");
    }
  }
  /*Base setting for slider view all*/


  if (getglobalLib("PDP_Slider_Thumbnail_Viewmore") == "on") {
    $(".js__pdp-thumbnail").addClass("js__pdp-thumbnail-view-more");
  } else {
    $(".js__pdp-thumbnail").addClass("js__pdp-thumbnail-slider");
  }
  /*Slider working Start*/

  /* Main SLIDER  initialization */


  $(".pdp-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    adaptiveHeight: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: true
      }
    }]
  });
  $(".js__pdp-thumbnail-slider").not(".slick-initialized").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    centerMode: false,
    infinite: false,
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: true,
    variableWidth: false,
    arrows: true,
    responsive: [{
      breakpoint: 981,
      settings: {
        verticalSwiping: false,
        vertical: false,
        slidesToShow: 5,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        verticalSwiping: false,
        vertical: false,
        dots: true,
        arrows: false
      }
    }]
  });
  /* Call page load functions */

  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  loopThroughEachCheckedVariantAddToArray();
  /* if no varient then active class added in product image section*/

  if (prodLib.length == 0) {
    $(".js-pdp-media").addClass("active");
    $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
  }
  /*Color Swatch working start*/

  /*
   Choose which color is checked and add class active to that
   Also update the slider thumbs
   */


  colorSelected = $('input[name="typecolor"]:checked').parent("li").attr("data-color-type");
  var colorLoadOption = colorSelected;

  try {
    colorLoadOption = colorLoadOption.replace(/[^a-zA-Z0-9 ]/g, "-");
    colorLoadOption = colorLoadOption.replace(/ /g, "-");
    colorLoadOption = colorLoadOption.replace(/--/g, "-");
    colorLoadOption = colorLoadOption.replace(/---/g, "-");
    $(".js-variant-color li[data-color-type=" + colorLoadOption + "]").addClass("active");
    $(".js-selected-color").html(colorSelected.replace("-", " "));
  } catch (_unused) {}

  showSelectedColorThumb();
  /*Color drop down open close*/

  $(".js__colorDropdown").children(".selected-color-section").click(function () {
    if ($(".js-variant-color").css("display") == "none") {
      $(".js-variant-color").slideDown();
    } else {
      $(".js-variant-color").slideUp();
    }
  });
  /*Load more click color swatch*/

  if (getglobalLib("Color_Swatches") == "yes") {
    if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
      var x = $("#js-variant-show-more li").length;
      $("#load-more").hide();
      console.log("x" + x);
      $(".js-variant-color li").hide();
      console.log("colorSwatchLimit" + colorSwatchLimit);

      if (x > colorSwatchLimit) {
        $("#load-more").show();
      }

      $("#js-variant-show-more li").slice(0, colorSwatchLimit).show();
    }
  }

  $("#load-more").on("click", function (e) {
    e.preventDefault();
    $("#js-variant-show-more li").show();
    $("#load-more").hide();
  });
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */

  function setColorThumbImages() {
    if ($(".js-variant-color li")[0]) {
      $(".js-variant-color li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color);
        $(this).children("img").css("opacity", "1");

        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }

        $(this).children("img").attr("src", colorValue);
      });
    }
  }
  /*PENDING*/

  /* 
  On click of size radio button
  1. Set the Dropdown Value to the selected Size
  2. Update the label value to the selected Size
  3. Loop through the color thumbs to mark from out of stock if the color isn't there for the size selected
  4. After selectio - Slide Up the dropdpown
  */

  /* OUT OF STOCK: Loop through color thumbs to set out of stock message and show quantity message */


  function loopThroughColorThumbs(colorSelected) {
    // console.log("size" + colorSelected)
    try {
      colorSelected = colorSelected.toLowerCase();
    } catch (_unused2) {}

    var sizeVariantCount = 0;
    $("#ProductSelect-option-1 .variantsRadioSectionOption .variantsRadioOption input").each(function (index) {
      sizeVariantCount++;
    }); //debugger;

    var variantValue;
    $(".js__secondOptionDD").children(".optionSizeRadioOuter").addClass("disabled");
    $(".variantsRadioOptionPrice").html("");
    $(".js-variant-color li").removeClass("out-of-stock");
    $(".js-variant-color li").removeClass("unavailable");
    /*
    Loop Through each input radio for the color
    */

    $("#ProductSelect-option-1 .variantsRadioSectionOption .variantsRadioOption input").each(function (index) {
      var passedElement = this;
      variantValue = $(this).val();
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */
      //var boolVariant=false;

      $(".js-sku-section").hide();
      $(".js-pdp-sku").html("");
      $.each(prodLib, function (key, value) {
        var itemQuantity = value.quantity;
        var itemAvailable = value.available;
        var colorOptionValue = "";
        var secondOptionValue = "";
        var thirdOptionValue = "";

        if (colorPosition == "1") {
          colorOptionValue = value.option1;
          secondOptionValue = value.option2;
          thirdOptionValue = value.option3;
        }

        if (colorPosition == "2") {
          colorOptionValue = value.option2;
          secondOptionValue = value.option1;
          thirdOptionValue = value.option3;
        }

        if (colorPosition == "3") {
          colorOptionValue = value.option3;
          secondOptionValue = value.option1;
          thirdOptionValue = value.option2;
        }
        /* COMMENTS REQUIRED
         what happens when quantoty = 0 explain
         */
        // console.log("colorSelected" + colorSelected)
        // console.log("secondOptionVariantValue" + secondOptionVariantValue)

        /*third option checking*/


        if ($("#hiddenpacksize").val() == "true") {
          /*three matching option checking for sku and quantity*/
          if (colorSelected == colorOptionValue.toLowerCase() && secondOptionVariantValue.toLowerCase() == secondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == thirdOptionValue.toLowerCase()) {
            // console.log("if secondOptionVariantValue" + secondOptionVariantValue)
            if (value.sku != "") {
              $(".js-pdp-sku").html(value.sku);
              $(".js-sku-section").show();
            }
          } else {
            if (secondOptionVariantValue.toLowerCase() == secondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == thirdOptionValue.toLowerCase()) {
              // console.log("if secondOptionVariantValue" + secondOptionVariantValue)
              if (value.sku != "") {
                $(".js-pdp-sku").html(value.sku);
                $(".js-sku-section").show();
              }
            }
          }
        } else {
          /*two matching option checking for sku and quantity*/
          if (colorSelected == colorOptionValue.toLowerCase() && secondOptionVariantValue.toLowerCase() == secondOptionValue.toLowerCase()) {
            // console.log("if secondOptionVariantValue" + secondOptionVariantValue)
            if (value.sku != "") {
              $(".js-pdp-sku").html(value.sku);
              $(".js-sku-section").show();
            }
          }
        }
        /*Checking each color  size quantity and which have 0 then added out of stock class*/


        if ($("#hiddenpacksize").val() == "true") {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == secondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == thirdOptionValue.toLowerCase()) {
            if (itemQuantity < 1 && itemAvailable == "false") {
              var colorOption = colorOptionValue;
              colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
              colorOption = colorOption.replace(/ /g, "-");
              colorOption = colorOption.replace(/--/g, "-");
              colorOption = colorOption.replace(/---/g, "-");
              $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("out-of-stock");
              /*Checking if only one size and color varient out of stock then remove that color*/

              if (sizeVariantCount == 1 && secondOptionVariantValue != "") {
                if ($("#js-variant-show-more li").length < colorSwatchLimit) {
                  if (getglobalLib("Color_Swatches") == "yes") {
                    if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
                      $("#load-more").hide();
                      $(".js-variant-color li").show();
                    }
                  }
                }

                $(".js-variant-color li[data-color-type=" + colorOption + "]").remove();
              }
            }
          }
        } else {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (secondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            // console.log(itemQuantity);
            // console.log(value.option1);
            // console.log(secondOptionVariantValue);
            if (itemQuantity < 1 && itemAvailable == "false") {
              console.log("if222");
              var colorOption = colorOptionValue;
              colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
              colorOption = colorOption.replace(/ /g, "-");
              colorOption = colorOption.replace(/--/g, "-");
              colorOption = colorOption.replace(/---/g, "-");
              $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("out-of-stock");
              /*Checking if only one size and color varient out of stock then remove that color*/

              if (sizeVariantCount == 1 && secondOptionVariantValue != "") {
                if (getglobalLib("Color_Swatches") == "yes") {
                  if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
                    console.log("if333");

                    if ($("#js-variant-show-more li").length < colorSwatchLimit) {
                      $("#load-more").hide();
                      $(".js-variant-color li").show();
                    }
                  }
                }

                $(".js-variant-color li[data-color-type=" + colorOption + "]").remove();
              }
            }
          }
        }
      });
    });
    /*Checking Unavailable and then adding out of stock */

    $(".js-variant-color li").each(function (index) {
      var color = $(this).attr("data-color");
      var boolVariant = false; // console.log("color22" + color)
      // console.log("size22" + secondOptionVariantValue)

      $.each(prodLib, function (key, value) {
        var colorOptionValue = "";
        var secondOptionValue = "";
        var thirdOptionValue = "";

        if (colorPosition == "1") {
          colorOptionValue = value.option1;
          secondOptionValue = value.option2;
          thirdOptionValue = value.option3;
        }

        if (colorPosition == "2") {
          colorOptionValue = value.option2;
          secondOptionValue = value.option1;
          thirdOptionValue = value.option3;
        }

        if (colorPosition == "3") {
          colorOptionValue = value.option3;
          secondOptionValue = value.option1;
          thirdOptionValue = value.option2;
        }

        if (colorOptionValue == color) {
          if ($("#hiddenpacksize").val() == "true") {
            if (secondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && thirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              boolVariant = true;
            }
          } else {
            if (secondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              boolVariant = true;
            }
          }
        }
      }); // console.log(boolVariant)

      if (boolVariant == false) {
        var colorOption = color;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("out-of-stock");
        $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("unavailable");
        /*Checking if only one size and color varient out of stock then remove that color*/

        if (sizeVariantCount == 1 && secondOptionVariantValue != "") {
          //  alert($(".js-variant-color li").length)
          if (getglobalLib("Color_Swatches") == "yes") {
            if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
              if ($("#js-variant-show-more li").length < colorSwatchLimit) {
                $("#load-more").hide();
                $(".js-variant-color li").show();
              }
            }
          }

          $(".js-variant-color li[data-color-type=" + colorOption + "]").remove();
        }
      }
    });
    var colorSwatchCount = 0;
    $(".js-variant-color li").each(function (index) {
      if (!$(this).hasClass("unavailable")) {
        colorSwatchCount++;
      }
    });

    if (getglobalLib("Color_Swatches") == "yes") {
      if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
        if (colorSwatchCount < colorSwatchLimit) {
          $("#load-more").hide();
          $(".js-variant-color li").show();
        } else {
          $(".js-variant-color li").hide();
          $("#load-more").show();
          $("#js-variant-show-more li").slice(0, colorSwatchLimit).show();
        }
      }
    }
  }
  /******
     COLOR THUMB CLICK
     ******/


  $(".js-variant-color li").click(function () {
    //remove the active class from any color li
    $(".js-variant-color li").removeClass("active"); // add the active class

    $(this).addClass("active"); //set the color selected

    colorSelected = $(this).attr("data-color");
    /* On click of colors loop through all color thumbs to set out of stock working + show quantity message */

    loopThroughColorThumbs(colorSelected);
    /*
    fire the radio button click and add checked
    Need to replace - with space as the variants have space in between in actual radio button
    */
    //set the color selected to the label

    $(".js-selected-color").html(colorSelected.replace("-", " "));
    /*Slider and thumbnail filter*/

    showSelectedColorThumb(colorSelected);
    $("input[name=color][value='" + colorSelected + "']").click();
    $("input[name=color][value='" + colorSelected + "']").prop("checked", true);
    $("input[name=typecolor][colorValue='" + colorSelected + "']").prop("checked", true);

    if (getglobalLib("Variant_Display") == "dropdown") {
      /*Varient color swatch in on off*/
      if (getglobalLib("Color_Swatches") != "yes") {
        $(".js-variant-color").slideUp();
      }
    }
  });
  /*Pending*/

  /* For selected color setting slider thumb and main slider reset*/

  function showSelectedColorThumb() {
    //debugger;
    try {
      var ImageColorToLowerCase = colorSelected.toLowerCase();
    } catch (_unused3) {}

    var colorSize = ImageColorToLowerCase;

    if (secondOptionVariantValue != "") {
      colorSize = ImageColorToLowerCase + "~" + secondOptionVariantValue.toLowerCase();
    }

    if (colorSelected != "" && colorSelected != undefined) {
      try {
        var thumbColorSelected = colorSelected.replace(" ", "-");
        thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
        thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
        thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
        thumbColorSelected = thumbColorSelected.replace(/---/g, "-");
        $(".pdp-slider").slick("slickUnfilter");
        $(".pdp-slider").find(".all").addClass(thumbColorSelected);
        +$(".js__pdp-thumbnail-slider").find(".all").addClass(thumbColorSelected); // console.log("filtercheck" + thumbColorSelected);

        $(".pdp-slider").slick("slickFilter", "." + thumbColorSelected);
        $(".js__pdp-thumbnail-slider").slick("slickUnfilter"); // console.log("filtercheck" + thumbColorSelected);

        $(".js__pdp-thumbnail-slider").slick("slickFilter", "." + thumbColorSelected);
        $(".js-pdp-media").addClass("active");
        $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
        /*Zoom adding*/

        if ($(window).width() > 768) {
          if (getglobalLib("Image_Zoom") == "yes") {
            $(".pdp-slider li:first-child").children(".image-section").children("img").ezPlus({
              zoomType: "inner",
              cursor: "crosshair",
              responsive: "true"
            });
          }
        } else {
          $(".zoomContainer").remove();
        }
      } catch (_unused4) {}

      var thumbExtraCount = 0;
      var thumbCount = 1;
      $(".js__pdp-thumbnail-view-more").empty();
      $("#lightgallery").empty();
      var productTitle = $(".js__pdp-title").html();
      /*Product thumb checking with dd selected and thumb and slider image reset*/

      try {
        $(".js-productDetailThumbImages-hidden  li").each(function () {
          try {
            var imgAlt = $(this).children(".image-section").children("img").attr("alt").toLowerCase().split(" / ")[1].split("-")[1];

            if (imgAlt == ImageColorToLowerCase) {
              var img = $(this).children(".image-section").children("img").attr("src");
              $("#lightgallery").append("<a href=" + img + ' title="' + productTitle + '" >' + productTitle + "<img src=" + img + " alt=" + imgAlt + "> </a>");

              if (thumbCount == 1) {
                $(".js__pdp-thumbnail-view-more").append('<li class="active"><div class="image-section"><img src="' + img + '" alt="' + imgAlt + '"></div></li>');
              } else {
                if (thumbCount > 7) {
                  $(".js__pdp-thumbnail-view-more").append('<li style="display:none"><div class="image-section"><img src="' + img + '" alt="' + imgAlt + '"></div></li>');
                } else {
                  $(".js__pdp-thumbnail-view-more").append('<li><div class="image-section"><img src="' + img + '" alt="' + imgAlt + '"></div></li>');
                }
              }

              thumbCount++;
            }
          } catch (_unused5) {}
        });
      } catch (_unused6) {}

      if (thumbCount > 7) {
        thumbExtraCount = thumbCount - 8;
        $(".js__pdp-thumbnail-view-more").append('<li class="js__thumb-number-section"><div class="number-section">+' + thumbExtraCount + "</div></li>");
      }

      lightGallery(document.getElementById("lightgallery"), {
        thumbnail: true,
        thumbWidth: 70,
        thumbContHeight: 70,
        toggleThumb: false
      });
    } else {
      $(".js-pdp-media").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
    }
  }
  /*Color Swatch workign end*/

  /*Radio dd working start*/

  /* Loop through each Size options and show the selected size */


  $(".optionSizeRadioOuter").each(function () {
    if ($(this).children(".variantsRadioOption").is(":checked")) {
      secondOptionVariantValue = $(this).children(".optionSizeRadio").children(".js-variantsRadioOptionValue").html();
      $(".js__secondOptionDD_Outer").find("p").html(secondOptionVariantValue);
      /*Color thumbs, out of stock and unavailable */

      setTimeout(function () {
        loopThroughColorThumbs(colorSelected);
      }, 1000);

      if (getglobalLib("Variant_Display") == "dropdown") {
        $(".js__secondOptionDD").slideUp();
      }

      secondOptionVariantValue = secondOptionVariantValue.toLowerCase();
    }
  });
  /*PENDING Class and variable name is wrong */

  /*Variant radio button click */

  $(".js__secondOptionDD input[type=radio]").click(function () {
    //Set selected value
    secondOptionVariantValue = $(this).parent("div").children("label").children(".js-variantsRadioOptionValue").html();

    try {
      //add checked attribute
      $(".variantsRadioOption [value=" + secondOptionVariantValue + "]").attr("checked", "checked");
    } catch (_unused7) {} //Show selected value in a label


    $(".js__secondOptionDD_Outer").find("p").html(secondOptionVariantValue);
    /*Color thumbs, out of stock and unavailable */

    loopThroughColorThumbs(colorSelected);
    /*Formatting: Custom DD design */

    if (getglobalLib("Variant_Display") == "dropdown") {
      $(".js__secondOptionDD").slideUp();
    }

    secondOptionVariantValue = secondOptionVariantValue.toLowerCase();
  });
  /*PENDING Class and variable name is wrong 
  merge top and bottom code
  */

  $(".js__thirdOptionDD input[type=radio]").click(function () {
    thirdOptionVariantValue = $(this).parent("div").children("label").children(".js-variantsRadioOptionValue").html();

    try {
      $(".variantsRadioOption [value=" + thirdOptionVariantValue + "]").attr("checked", "checked");
    } catch (_unused8) {}

    $(".js__thirdOptionDD_Outer").find("p").html(thirdOptionVariantValue.toLowerCase());
    loopThroughColorThumbs(colorSelected);

    if (getglobalLib("Variant_Display") == "dropdown") {
      $(".js__thirdOptionDD").slideUp();
    }

    thirdOptionVariantValue = thirdOptionVariantValue.toLowerCase();
  });
  /*PENDING Class and variable name is wrong */

  /*PAGE LOAD: Loop through each Pack Size options and show the selected size */

  $(".optionPackSizeRadioOuter").each(function () {
    // console.log("thirdOptionVariantValue");
    if ($(this).children(".variantsRadioOption").is(":checked")) {
      thirdOptionVariantValue = $(this).children(".optionPackSizeRadio").children(".js-variantsRadioOptionValue").html().toLowerCase(); // console.log(thirdOptionVariantValue);

      $(".js__thirdOptionDD_Outer").find("p").html(thirdOptionVariantValue);
    }
  });
  /*PENDING Class and variable name is wrong */

  /* FORMATTING: Custom On click of size DropDown - open the list and hide the color selection dropdown open list*/

  $(".js__secondOptionDD_Outer p").click(function () {
    if (getglobalLib("Variant_Display") == "dropdown") {
      if ($(".js__secondOptionDD").css("display") == "none") {
        $(".js__secondOptionDD").slideDown();
        $(".js__thirdOptionDD").hide();
      } else {
        $(".js__secondOptionDD").slideUp();
      }
    }
  });
  /*PENDING Class and variable name is wrong */

  /* FORMATTING: Custom On click of pack size DropDown - open the list and hide the color selection dropdown open list*/

  $(".js__thirdOptionDD_Outer p").click(function () {
    if ($(".js__thirdOptionDD").css("display") == "none") {
      $(".js__thirdOptionDD").slideDown();
      $(".js__secondOptionDD").hide();
    } else {
      $(".js__thirdOptionDD").slideUp();
    }
  });
  /*Radio dd working end*/

  /*
   PDP: Radio Button Click
   */

  /* ON PAGE LOAD
    Get the value of the checked radio button for all the types
   get the name and value e.g. name = color, value = red */

  function loopThroughEachCheckedVariantAddToArray() {
    $(".js-fieldset-variant .variantsRadioSectionOption .variantsRadioOption input:checked").each(function (index) {
      var variantKey = $(this).attr("name");
      var variantValue = $(this).val();
      /* Adding a map of name to value */

      variantOptionArray[variantKey] = variantValue;
      variantSelection(this);
      console.log(variantOptionArray);
    });
  }
  /*******
  RADIO BUTTON CLICK 
   *******/


  $(".product-actions-wrapper .js-optionRadio").click(function (e) {
    //debugger;
    console.log("------------------------- BEGIN------------------");
    variantSelection(this);
  });

  function variantSelection(passedElement) {
    // debugger;
    // $(".js-add-to-cart-btn").prop("disabled", true);

    /*
    Get the clicked radio button  name and value
    */
    var variantValue = $(passedElement).parent(".variantsRadioOption").children("input").val();
    var variantKey = $(passedElement).parent(".variantsRadioOption").children("input").attr("name");
    /* Check if the key exists in the array or not 
    if it exists, then update the key with the new value
    e.g. on load color = red
    but on click  - color = blue
    */

    if (variantKey in variantOptionArray) {
      console.log("TRUEEEEEEE KEY EXISTS IN THE ARRAY");
      console.log(variantKey);
      variantOptionArray[variantKey] = variantValue; // if key exists, then don't do anything
    }

    console.log(variantOptionArray);
    /* Set the variant ID */

    loopThroughProductLiquidVariable();
    var count = 1;
    /* go through each select options */

    $(".selector-wrapper").each(function (index) {
      console.log("count" + count);
      var checkSelectLabelVal = $(this).children("label").text().toLowerCase();
      console.log("checkSelectLabelVal" + checkSelectLabelVal);
      console.log("variantKey" + variantKey);
      console.log("variantValue" + variantValue);

      if (checkSelectLabelVal.replace(/ /g, "-").trim() == variantKey) {
        //console.log($(this).children("label").text().toLowerCase());

        /*fire the select change for that option and set it's value */
        console.log("ifvariantValue" + variantValue);
        $(this).children("select").val(variantValue);
        $(this).children("select").change();
      }

      count++;
    });
  }
  /* */


  function loopThroughProductLiquidVariable() {
    selectedVariantArray = Object.keys(variantOptionArray);
    /* get the variant ID */

    if (typeof prodLib !== "undefined") {
      $.each(prodLib, function (key, value) {
        if (selectedVariantArray.length == 1 && variantOptionArray[selectedVariantArray[0]] == value.option1) {
          selectedVariantID = value.id;
          $(".js-add-to-cart-btn").removeClass("hide");
        }

        if (selectedVariantArray.length == 2 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2) {
          selectedVariantID = value.id;
          $(".js-add-to-cart-btn").removeClass("hide");
        }

        if (selectedVariantArray.length == 3 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2 && variantOptionArray[selectedVariantArray[2]] == value.option3) {
          //  console.log("case 3");
          //  console.log(value.id);
          // console.log("price: " + value.price);
          // console.log("compared price: " + value.priceCompared);
          selectedVariantID = value.id;
          $(".js-add-to-cart-btn").removeClass("hide");
        }
      });
    }
  }
  /*Quantity Plus Minus*/


  $(".js-product-single__quantity .js__minus-qty").click(function () {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  });
  $(".js-product-single__quantity .js__plus-qty").click(function () {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  });
  /* Add to cart working */

  $(".js-add-to-cart-btn").click(function () {
    if (prodLib.length == 0) {
      selectedVariantID = $(this).attr("data-attr-itemid"); //console.log("selectedVariantID: when NULL: " + selectedVariantID);
    } else {}

    selectedVariantID = parseInt(selectedVariantID);
    console.log("selectedVariantID:: " + selectedVariantID);
    var submitCartText = $(".js-add-to-cart-btn").html().toLowerCase();

    if (submitCartText == "add to cart") {
      var cartSuccess = false;
      var quantity = parseInt($(".js__quantity-selector").val());
      var items = [];
      /* For the main item */

      items.push({
        id: selectedVariantID,
        quantity: quantity
      });
      CartJS.addItems(items, {
        success: function success(response, textStatus, jqXHR) {
          CartJS.getNote();
          console.log(response);
          cartSuccess = true;

          if (getglobalLib("Mini_Cart") == "yes") {
            quickCartTotal(); // if you want to show success message

            if (successErrorMessageVisible == true) {
              showCartSuccessMessage();
            }

            setTimeout(openMiniCart, 1000);
          } else {
            window.location = "/cart";
          }
        },
        // Define an error callback to display an error message.
        error: function error(jqXHR, textStatus, errorThrown) {
          // if you want to show error message
          if (successErrorMessageVisible == true) {
            showCartErrorMessage();
          }
        }
      });
    }
  });
});
/*PENDING Get Variant Color*/

function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    return variantColorValue;
  } catch (_unused9) {}
}
/*function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodLib, function (key, value) {
      if (color.toLowerCase() == value.option1.toLowerCase()) {
        variantColorValue = value.image;
      }
    });
    return variantColorValue;
  } catch {}
}*/
"use strict";

jQuery(function () {
  /*Number click*/
  $(document).on("click", ".js__thumb-number-section", function (e) {
    console.log(getglobalLib("Image_Popup"));

    if (getglobalLib("Image_Popup") == "yes") {
      console.log("if main");
      /*If global setting set popup then popup will open otherswise all lis will open*/

      if (getglobalLib("PDP_Thumbnail_Viewmore_Click") == "popup") {
        $("#lightgallery a:nth-child(8) > img").trigger("click");
        console.log("if inner");
      } else {
        console.log("else inner");
        $(".js__pdp-thumbnail-view-more li").show();
        $(this).hide();
      }
    } else {
      console.log("else main");
      /*Showing all thumbnail*/

      $(".js__pdp-thumbnail-view-more li").show();
      $(this).hide();
    }
  });
  /* open light box in small screen from 768px*/

  $(document).on("click", ".js__pdp-slider li", function (e) {
    e.preventDefault();
    var slideno = $(this).index();
    var child = slideno + 1;

    if ($(window).width() < 769) {
      if (getglobalLib("Image_Popup") == "yes") {
        $("#lightgallery a:nth-child(" + child + ") > img").trigger("click");
      }
    }
  });
  /*Pending More Comment*/

  /* Image Popup Visiblity */

  if (getglobalLib("Image_Popup") == "yes") {
    $(".js__pdp-img-popup").removeClass("hide");
    $(".js__pdp-thumbnail").removeClass("mt-45");
  }
  /* Manual click of thumbnail of slider*/


  $(document).on("click", ".pdp-thumbnail li", function (e) {
    if (!$(this).hasClass("js__thumb-number-section")) {
      e.preventDefault();
      var slideno = $(this).index();
      var child = slideno + 1;
      console.log("slideno" + slideno);
      $(".pdp-thumbnail li").removeClass("active");
      $(this).addClass("active");
      $(".pdp-slider").slick("slickGoTo", slideno);
      /*Pending More Comment*/

      $(".zoomContainer").remove();

      if ($(window).width() > 768) {
        if (getglobalLib("Image_Zoom") == "yes") {
          $(".pdp-slider li:nth-child(" + child + ")").children(".image-section").children("img").ezPlus({
            zoomType: "inner",
            cursor: "crosshair",
            responsive: "true"
          });
        }
      } else {
        $(".zoomContainer").remove();
      }
    }

    $(".video-slide video")[0].pause();
  });
  /*Slider working End*/

  /* Top Write review button click scroll to bottom review section and open write review section*/

  $(document).on("click", ".write-review-btn-hidden", function () {
    $(".tab-link").removeClass("active");
    $(".tab-link [data-attr=reviews]").addClass("active");
    $(".write-review-button").click();
    $(".tab-content").removeClass("active");
    $("#reviews").addClass("active");
    var target = $("#reviews").children(".inner-content");
    setTimeout(function () {
      $("html, body").animate({
        scrollTop: target.offset().top - 200
      }, 500);
    }, 500);
  });
  /* PENDING*/

  $(".js__accordian-tab-pdp").click(function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".inner-content").css("display") == "none") {
      $(".js__tab li").removeClass("active");
      $(".tab-content").removeClass("active");
      $(".tab-content").children(".inner-content").hide();
      $(this).parent(".tab-content").children(".inner-content").slideDown();
      $(this).parent(".tab-content").addClass("active");
      var target = $(this).parent(".tab-content").children(".inner-content");
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: target.offset().top - 200
        }, 500);
      }, 500);
    } else {
      $(this).parent(".tab-content").children(".inner-content").slideUp();
      $(this).parent(".tab-content").removeClass("active");
    }
  });
  /*View details*/

  $(document).on("click", ".js__pdp-view-details", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $(".js__pdp_details").addClass("active");
    $(".tab-content").removeClass("active");
    $("#details").addClass("active");

    if ($(window).width() < 769) {
      $(".tab-content").children(".inner-content").hide();
      $("#details").children(".inner-content").show();
    } else {
      $(".tab-content").hide();
      $("#details").show();
    }

    setTimeout(function () {
      var target = $("#details");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });
});
